module.exports = __webpack_public_path__ + "img/GENOVA.009cef7a.png";